import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useAppSelector } from '@spartalabs/pdc-core';
import usePageTracking from 'hooks/usePageTracking';
import {
  Login,
  Home,
  Empty,
  EntranceExit,
  Examples,
  CardsExamples,
  ChartsExamples,
  TablesExamples,
  FleetDist,
  Repair,
  Models,
} from 'pages';
import {} from 'pages/Reports/Maintenance/Repair';
import { Schedules } from 'pages/Schedules';
import { NewScheduleHeader } from 'pages/Schedules/components/NewScheduleHeader';
import { ScheduleForm } from 'pages/Schedules/components/ScheduleForm';
import { ServicesForm } from 'pages/Schedules/components/ServicesForm';
import { VehicleForm } from 'pages/Schedules/components/VehicleForm';
import { isProd } from 'utils/functions';

export const AppRoutes = () => {
  if (isProd()) usePageTracking();

  const {
    user: { token },
  } = useAppSelector(state => state.authSlicer);

  if (!token) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/inicio" />} />
      <Route path="/login" element={<Login />} />
      <Route path="/inicio" element={<Home />} />
      <Route path="/examples" element={<Examples />} />
      <Route path="/relatorios">
        <Route path="modelos" element={<Models />} />
        <Route path="manutencao">
          <Route path="entradasaida" element={<EntranceExit />} />
          <Route path="servicos" element={<Repair />} />
        </Route>
        <Route path="distdefrotas" element={<FleetDist />} />
      </Route>
      <Route path="/agendamentos" element={<Schedules />} />
      <Route path="/novo-agendamento" element={<NewScheduleHeader />} />
      <Route path="/novo-agendamento/veiculos" element={<VehicleForm />} />
      <Route path="/novo-agendamento/servicos" element={<ServicesForm />} />
      <Route path="/novo-agendamento/agenda" element={<ScheduleForm />} />

      <Route path="/exemplos">
        <Route path="" element={<Examples />} />
        <Route path="cards" element={<CardsExamples />} />
        <Route path="graficos" element={<ChartsExamples />} />
        <Route path="tabelas" element={<TablesExamples />} />
      </Route>
      <Route path="*" element={<Empty />} />
    </Routes>
  );
};
